// Used when a page doesn't set window.configAlertTimeout, so a toast never disappears the moment it shows
const DEFAULT_TOAST_MS = 5000;
// Matches the pp-toast-leave animation in theme-base.css; also the fallback when animations are off
const TOAST_LEAVE_MS = 200;

const icons = {
    success: "bi-check-circle-fill",
    danger: "bi-x-circle-fill",
    warning: "bi-exclamation-triangle-fill",
    info: "bi-info-circle-fill"
};

const titles = {
    success: "Success",
    danger: "Error",
    warning: "Warning",
    info: "Info"
};

export function toastDuration(timeout_ms) {
    const duration = Number(timeout_ms);
    return duration > 0 ? duration : DEFAULT_TOAST_MS;
}

export function showToastMessage(
    message,
    type = "success",
    timeout_ms = window.configAlertTimeout,
    action = null
) {
    const alertContainer = document.getElementById("alert-container");
    const wrapper = document.createElement("div");
    wrapper.className = "pp-toast-wrapper";
    const duration = toastDuration(timeout_ms);
    // Problems interrupt a screen reader; confirmations wait their turn
    const urgent = type === "danger" || type === "warning";

    wrapper.innerHTML = `
        <div class="pp-toast pp-toast-${type}" role="${urgent ? "alert" : "status"}">
            <div class="pp-toast-header">
                <i class="bi ${icons[type]} pp-toast-icon" aria-hidden="true"></i>

                <span class="pp-toast-title">
                    ${titles[type]}
                </span>

                <button type="button"
                        class="btn-close"
                        aria-label="Close">
                </button>
            </div>

            <div class="pp-toast-message"></div>

            <div class="pp-toast-progress"></div>
        </div>
    `;

    // Set as text, so a message that includes server or user content can't add markup to the page
    wrapper.querySelector(".pp-toast-message").textContent = String(message);
    // The bar runs for exactly as long as the toast stays up
    wrapper.querySelector(".pp-toast-progress").style.animationDuration = `${duration}ms`;

    let remaining = duration;
    let startedAt = 0;
    let timer = null;
    let leaving = false;

    const dismiss = () => {
        if (leaving) {
            return;
        }
        leaving = true;
        clearTimeout(timer);
        wrapper.classList.add("pp-toast-leaving");
        // animationend doesn't fire when reduced motion turns the animation off, so don't wait on it alone
        wrapper.addEventListener("animationend", () => wrapper.remove(), { once: true });
        setTimeout(() => wrapper.remove(), TOAST_LEAVE_MS);
    };

    const start = () => {
        startedAt = Date.now();
        timer = setTimeout(dismiss, remaining);
        wrapper.classList.remove("pp-toast-paused");
    };

    // Hold the toast while the pointer or keyboard focus is on it, so its button can still be reached
    const pause = () => {
        if (leaving || timer === null) {
            return;
        }
        clearTimeout(timer);
        timer = null;
        remaining = Math.max(remaining - (Date.now() - startedAt), 0);
        wrapper.classList.add("pp-toast-paused");
    };

    const resume = () => {
        if (leaving || timer !== null || wrapper.matches(":hover") || wrapper.contains(document.activeElement)) {
            return;
        }
        start();
    };

    if (action) {
        const actionButton = document.createElement("button");
        actionButton.type = "button";
        actionButton.className = "pp-toast-action";
        actionButton.textContent = action.label;
        actionButton.addEventListener("click", () => {
            leaving = true;
            clearTimeout(timer);
            wrapper.remove();
            action.onClick();
        });
        wrapper.querySelector(".pp-toast-message").append(actionButton);
    }

    alertContainer.append(wrapper);

    wrapper.querySelector(".btn-close").addEventListener("click", dismiss);
    wrapper.addEventListener("mouseenter", pause);
    wrapper.addEventListener("mouseleave", resume);
    wrapper.addEventListener("focusin", pause);
    wrapper.addEventListener("focusout", () => setTimeout(resume));

    start();
}
